var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Seiten importieren"),
      confirmText: _vm.$gettext("Importieren"),
      confirmDisabled: _vm.importRunning || _vm.importAborted,
      closeText:
        _vm.importRunning || _vm.importAborted
          ? _vm.$gettext("Schließen")
          : _vm.$gettext("Abbrechen"),
      height: "420",
    },
    on: {
      close: function close($event) {
        return _vm.showElementImportDialog(false)
      },
      confirm: _vm.importCoursewareArchiv,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            !_vm.importRunning && !_vm.importAborted
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("label", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("Importdatei")) +
                          "\n                "
                      ),
                      _c("input", {
                        ref: "importFile",
                        staticClass: "cw-file-input",
                        attrs: {
                          type: "file",
                          accept: ".zip",
                        },
                        on: {
                          change: _vm.setImport,
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$gettext("Importverhalten")) +
                          "\n            "
                      ),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.importBehavior,
                              expression: "importBehavior",
                            },
                          ],
                          on: {
                            change: function change($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.importBehavior = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "default",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$gettext("Inhalte anhängen")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "migrate",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$gettext("Inhalte zusammenführen"))
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                attrs: {
                  role: "status",
                  "aria-live": "polite",
                },
              },
              [
                _c("courseware-companion-box", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.importDone && _vm.importErrors.length === 0,
                      expression: "importDone && importErrors.length === 0",
                    },
                  ],
                  attrs: {
                    msgCompanion: _vm.$gettext("Import erfolgreich!"),
                    mood: "special",
                  },
                }),
                _vm._v(" "),
                _c("courseware-companion-box", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.importDone && _vm.importErrors.length > 0,
                      expression: "importDone && importErrors.length > 0",
                    },
                  ],
                  attrs: {
                    msgCompanion: _vm.$gettext(
                      "Import abgeschlossen. Es sind Fehler aufgetreten!"
                    ),
                    mood: "unsure",
                  },
                }),
                _vm._v(" "),
                _c("courseware-companion-box", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.importDone && _vm.importRunning,
                      expression: "!importDone && importRunning",
                    },
                  ],
                  attrs: {
                    msgCompanion: _vm.$gettext(
                      "Import läuft. Bitte schließen Sie den Dialog nicht bis der Import abgeschlossen wurde."
                    ),
                    mood: "pointing",
                  },
                }),
                _vm._v(" "),
                _c("courseware-companion-box", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.importAborted,
                      expression: "importAborted",
                    },
                  ],
                  attrs: {
                    msgCompanion: _vm.$gettext(
                      "Import abgebrochen. Es sind Fehler aufgetreten!"
                    ),
                    mood: "sad",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.importDone && _vm.importRunning
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("fieldset", [
                      !_vm.fileImportDone
                        ? _c(
                            "div",
                            {
                              staticClass: "cw-import-zip",
                            },
                            [
                              _c("header", [
                                _vm._v(
                                  _vm._s(_vm.$gettext("Importiere Dateien")) +
                                    ":"
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "progress-bar-wrapper",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar",
                                      style: {
                                        width: _vm.importFilesProgress + "%",
                                      },
                                      attrs: {
                                        role: "progressbar",
                                        "aria-valuenow":
                                          _vm.importFilesProgress,
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.importFilesProgress) + "%"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.importFilesState) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.fileImportDone
                        ? _c(
                            "div",
                            {
                              staticClass: "cw-import-zip",
                            },
                            [
                              _c("header", [
                                _vm._v(
                                  _vm._s(_vm.$gettext("Importiere Elemente")) +
                                    ":"
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "progress-bar-wrapper",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar",
                                      style: {
                                        width:
                                          _vm.importStructuresProgress + "%",
                                      },
                                      attrs: {
                                        role: "progressbar",
                                        "aria-valuenow":
                                          _vm.importStructuresProgress,
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.importStructuresProgress) +
                                          "%"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.importStructuresState) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.importErrors.length > 0
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("fieldset", [
                      _c("legend", [
                        _vm._v(_vm._s(_vm.$gettext("Fehlermeldungen"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.importErrors, function (error, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                            },
                            [_vm._v(" " + _vm._s(error) + " ")]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }